import React from 'react';
import './heart.css';

export default function Heart({ bpm = 72 }) {
  // Slow the visual beat to feel calm and ambient (not literal real-time BPM)
  const beatDuration = (60 / bpm) * 1.8;

  return (
    <div
      className="heart-stage"
      style={{ '--beat-duration': `${beatDuration}s` }}
      aria-hidden="true"
    >
      <div className="heart-glow" />
      <div className="heart-pulse-ring" />
      <div className="heart-pulse-ring delay" />
      <svg
        className="heart-svg"
        viewBox="0 0 100 90"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <radialGradient id="heartGradient" cx="50%" cy="40%" r="60%">
            <stop offset="0%" stopColor="#ff6b6b" />
            <stop offset="55%" stopColor="#f01e02" />
            <stop offset="100%" stopColor="#7a0a00" />
          </radialGradient>
          <filter id="heartGlow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="2.5" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <path
          filter="url(#heartGlow)"
          fill="url(#heartGradient)"
          d="M50,82 C50,82 8,55 8,28 C8,14 19,4 32,4 C40,4 46,8 50,15 C54,8 60,4 68,4 C81,4 92,14 92,28 C92,55 50,82 50,82 Z"
        />
      </svg>
      <div className="heart-bpm">
        <span className="bpm-value">{bpm}</span>
        <span className="bpm-label">BPM</span>
      </div>
    </div>
  );
}
